<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
    <kendo-grid [kendoGridBinding]="workflowTemplateList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" [height]="600">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex flex-wrap flex-sm-nowrap">
                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="pagination-container" style="width:95%;padding-top: 10px;">
                    <EIPAutoComplete style="padding-right: 20px;width:25%;" ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription"  ValueField="dedId" [clearValue]='clearIcSelected' WaterMarkText="IC" [dataSource]='icList' setId="ddDiscpId7" (valueChange)='changeIc($event)' [IsCascading]='true' [IsDisabled]='icIsDisabled'>
                    </EIPAutoComplete>
                    <EIPAutoComplete style="padding-right: 20px; width:25%;" ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription"  ValueField="dedId" [clearValue]='clearBuSelected' WaterMarkText="BU" [dataSource]='buList' setId="ddDiscpId6" (valueChange)='changeBu($event)' [IsCascading]='true'>
                    </EIPAutoComplete>
                    <EIPAutoComplete style="padding-right: 20px; width:25%;" ShowTextValueField='N' floatLabelOption="never" WaterMarkText="Project" TextField="projectDescription" [clearValue]='clearProjectSelected' ValueField="projectId" [dataSource]='projectList' setId="ddMrlProjectId" (valueChange)='changeProject($event)' [IsCascading]='true' [IsDisabled]='projectIsDisabled'>
                    </EIPAutoComplete>
                    <EIPAutoComplete style="padding-right: 20px;width:25%;" ShowTextValueField='N' floatLabelOption="never" WaterMarkText="Business Group" TextField="group_Name" [clearValue]='clearBusinessGroupSelected' ValueField="group_Id" [dataSource]='businessGroupList' setId="ddMrlBusGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
                    </EIPAutoComplete>
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                </div>
                <div class="icons-container">
                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{' ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">                       
                        <div class="icon-wrap" (click)="toggleFilter()">
                            <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                            <span class="list-icon-name">Filter</span>
                        </div>
                        <div class="icon-wrap" (click)="clearSelectedFilter()">
                            <i class="fa fa-ban" title="Clear Filter" aria-hidden="true"></i>
                            <span class="list-icon-name">Clear Filter</span>
                        </div>
                        <div class="icon-wrap" (click)="toggleFullscreen()">
                            <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                            <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                        </div>
                    </div>
                    <div class="divider-container d-none d-md-block"><span></span></div>
                    <i class="fa fa-plus-circle" title="Create Workflow Template" (click)="openAddTemplateDialog(true,null, null, 'C')" aria-hidden="true"></i>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex+1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Template Name" field="workflowName" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.workflowName}}" eipTooltipPosition="auto">{{dataItem.workflowName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Description" field="workflowDescription" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.workflowDescription}}" eipTooltipPosition="auto">{{dataItem.workflowDescription}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Is for Supersede" [width]="80" field="dataItem.isForsupersede">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isForsupersede" [disabled]="true" [size]="small"></kendo-switch>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Is CCN Required" [width]="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.cnN_Required" [disabled]="true" [size]="small"></kendo-switch>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Is Active" [width]="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true" [size]="small"></kendo-switch>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Created By" field="createdBy" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.createdBy}}" eipTooltipPosition="auto">{{dataItem.createdBy}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="createdOn" title="Created On" [width]="110" filter="date" format="{0:dd-MMM-yyyy}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.createdOn| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                    {{dataItem.createdOn| date:'dd-MMM-yyyy'}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Modified By" field="modifiedBy" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.modifiedBy}}" eipTooltipPosition="auto">{{dataItem.modifiedBy}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="modifiedOn" title="Modified On" [width]="110" filter="date" format="{0:dd-MMM-yyyy}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.modifiedOn| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                    {{dataItem.modifiedOn| date:'dd-MMM-yyyy'}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Actions" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span>
                    <i class="fa fa-eye eip-link" title="View" (click)="openAddTemplateDialog(false, dataItem, true, 'V')" aria-hidden="true" style="cursor: pointer;font-size: 1.25em;"></i>&nbsp;&nbsp;
                    <i class="fa fa-pencil eip-link" title="Edit" (click)="openAddTemplateDialog(false, dataItem, false, 'E')" style="cursor: pointer;font-size: 1.25em;" aria-hidden="true"></i>&nbsp;&nbsp;
                    <i class="fa fa-trash eip-link" title="Delete" aria-hidden="true" (click)="deleteWorkflowRow(dataItem)" style="cursor: pointer;font-size: 1.25em;"></i>
                </span>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>